import styles from "./Product3DViewer.module.css";

const Product3DViewer = ({ src, title }) => {
    if (!src) return null;

    return (
        <div className={styles.viewerShell}>
            <iframe
                title={title || "LG RetailVerse 3D Viewer"}
                src={src}
                className={styles.viewerFrame}
                frameBorder="0"
                allow="xr-spatial-tracking"
                loading="lazy"
            />
        </div>
    );
};

export default Product3DViewer;